import React from 'react';
import PropTypes from 'prop-types';

import usePlans from 'components/Common/Affiliates/Hooks/usePlans';
import Table from 'components/new_ui/Table';

import columns from './columns';
import NoData from './NoData';

export default function Main({ affiliateId }) {
  const { plans } = usePlans(affiliateId);

  return (
    <div className="content">
      <section>
        <h1>My Enterprises</h1>
      </section>

      <section>
        <Table
          columns={columns}
          data={plans || []}
          loading={plans == null}
          noData={<NoData />}
          selectableRows={false}
        />
      </section>
    </div>
  );
}

Main.propTypes = {
  affiliateId: PropTypes.number.isRequired,
};
